import maxRadiusVendorCategories from './constants/maxRadiusVendorCategories';

export const vendors = {
    maxRadiusVendorCategories
};